import AuthDeviceScreen from '@/components/Auth/Device/AuthDeviceScreen'
import { useAppSelector } from '@/hooks/redux'
import { authSelectors } from '@/redux/reducers/auth/selectors'
import { Redirect } from 'expo-router'
import { FC } from 'react'

const Page: FC = () => {
    const currentProfile = useAppSelector(authSelectors.currentProfile)
    const profiles = useAppSelector(authSelectors.profiles)

    if (currentProfile) {
        return <Redirect href="/auth/profile-pin" />
    }

    if (profiles) {
        return <Redirect href="/auth/profiles" />
    }

    return <AuthDeviceScreen />
}

export default Page
